/* prettier-ignore */

import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { RestService } from './rest.service';
const SCRIPT_PATH_CHATBASE = 'https://www.chatbase.co/embed.min.js';
const SCRIPT_PATH = 'https://cicerone.cms-iurban.com/cicerone-chat.js';
// const SCRIPT_PATH = '/assets/cicerone-chat.js';

@Injectable({
    providedIn: 'root' 
})

export class ChatBotScriptService {
  public script: any;
  private renderer: Renderer2 = this.rendererFactory.createRenderer(null, null);

  constructor(
    @Inject(DOCUMENT) private document: Document, 
    private rendererFactory: RendererFactory2,
    private rest: RestService,
    private translate: TranslateService) 
  {}
 
  public loadJsScript(id: any, chatbase: boolean = false, lang): HTMLScriptElement {
    this.script = this.renderer.createElement('script');
    this.script.type = 'text/javascript';
    this.script.src = chatbase ? SCRIPT_PATH_CHATBASE : SCRIPT_PATH;
    this.script.id = id;
    this.script.setAttribute('chatbot-id', id);
    this.script.setAttribute('lang-code', lang);
    this.renderer.appendChild(this.document.body, this.script);
    return this.script;
  }

  public setLang(lang){
    this.script?.setAttribute('lang-code', lang);
  }

  loadChat(lang) {
    if ([17, 21, 28, 45].includes(this.rest?.device?.client)) {
      if (this.rest?.device?.client == 17)
        this.loadJsScript("oHH4v5Y3BKPibM1C6ucve", true, lang);
      if (this.rest?.device?.client == 21)
        this.loadJsScript("Bv4er99U819VuS4Hbyh-p", true, lang);
      if (this.rest?.device?.client == 28)
        this.loadJsScript("DGUstJluPYz3tjG8YOZfN", true, lang);
      if (this.rest?.device?.client == 45)
        this.loadJsScript("9REyM0uAkkXXxOKjDjOzI", true, lang);
      return;
    }
    if (!this.rest?.device?.chatBotId) return;
    this.loadJsScript(this.rest.device.chatBotId, false, lang);
  }
}